import * as Actions from "../action/payment";


const initialState = {
    paymentData: [], 
    loading :true
  };
   
  const paymentReducer = function (state = initialState, action) {
    switch (action.type) {
      case Actions.GET_PAYMENT: {
        return {
          ...state,
          paymentData: action.payload, 
          loading :false,
        };
      }
      case Actions.CREATE_PAYMENT: {
        return {...state, paymentData: action.payload};
      }
      case Actions.DELETE_PAYMENT: {
        return state.filter((item) => item._id !== action.payload);
      }
      case Actions.UPDATE_PAYMENT: {
        const updatedPaymentData = state.paymentData.map((item) => {
          if (item._id === action.payload._id) {
            return action.payload;
          }
          return item;
        });
        return {...state, paymentData: updatedPaymentData, loading: false};
      }
      default:
        return state;
    }
  };
  export default paymentReducer;